/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addScalarDependencies } from './dependenciesAddScalar.generated';
import { complexDependencies } from './dependenciesComplex.generated';
import { conjDependencies } from './dependenciesConj.generated';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated';
import { equalDependencies } from './dependenciesEqual.generated';
import { identityDependencies } from './dependenciesIdentity.generated';
import { isZeroDependencies } from './dependenciesIsZero.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated';
import { signDependencies } from './dependenciesSign.generated';
import { sqrtDependencies } from './dependenciesSqrt.generated';
import { subtractDependencies } from './dependenciesSubtract.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { unaryMinusDependencies } from './dependenciesUnaryMinus.generated';
import { zerosDependencies } from './dependenciesZeros.generated';
import { createQr } from '../../factoriesAny.js';
export var qrDependencies = {
  addScalarDependencies: addScalarDependencies,
  complexDependencies: complexDependencies,
  conjDependencies: conjDependencies,
  divideScalarDependencies: divideScalarDependencies,
  equalDependencies: equalDependencies,
  identityDependencies: identityDependencies,
  isZeroDependencies: isZeroDependencies,
  matrixDependencies: matrixDependencies,
  multiplyScalarDependencies: multiplyScalarDependencies,
  signDependencies: signDependencies,
  sqrtDependencies: sqrtDependencies,
  subtractDependencies: subtractDependencies,
  typedDependencies: typedDependencies,
  unaryMinusDependencies: unaryMinusDependencies,
  zerosDependencies: zerosDependencies,
  createQr: createQr
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesQr.generated.js
// module id = 1622
// module chunks = 0